export class ClosingDocumentsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getClosingDocuments({ companyId, loanId }) {
    return this.#http.get(`api/companies/${companyId}/loans/${loanId}/closing-package`);
  }
}
